import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

export interface ITransportadora {
  codParceiro: number;
  nomeParceiro: string;
  cnpj: string;
  codCidade: number;
  cidade: string;
  uf: string;
  inscricaoEstadual: string;
}

export interface ITransportadoraResponse {
  transportadoras: ITransportadora[];
  total: number;
}

export const transportadoraService = {
  getTransportadorasParceiras: (
    codCdd: number,
    parceiros: number[]
  ): Promise<AxiosResponse<ITransportadoraResponse>> =>
    UDNICK.callService('getTransportadorasParceiras', { codCdd, parceiros }),
};
